export const extractActionButtons = (
  text: string,
): { buttons: { label: string; action: string }[]; cleanedText: string } => {
  const regex = /```([\s\S]*?)```/g;
  let buttons: { label: string; action: string }[] = [];
  let cleanedText = text;

  // `matchAll`을 사용해 모든 ` ``` ` 블록을 찾음
  const matches = [...text.matchAll(regex)];

  matches.forEach((match) => {
    if (match[1]) {
      const extractedButtons = [...match[1].matchAll(/\[(.*?)\]\(action:(.*?)\)/g)].map((m) => ({
        label: m[1],
        action: m[2],
      }));

      buttons = [...buttons, ...extractedButtons];

      cleanedText = cleanedText.replace(match[0], '').trim();
    }
  });

  return { buttons, cleanedText };
};
